import axios from 'axios';
import Cookie from 'js-cookie';
import { authTokenInCookie } from '../../utils/auth';
import { failedToast } from '../../utils/format';
import { authTokenName } from '../../config';
import { cookieDomain } from '../../env';
import { getGlobalLocaleMsg } from '../../utils/base';

interface ApiRequestParams {
  [key: string]: any;
}
interface ApiRequestExternals {
  [key: string]: any;
}
export interface ApiResponse<T> {
  status: string | number;
  result: T;
}

export interface IGatewayRes {
  ext_code: string;
  ext_info: string;
  ret_code: number;
  ret_msg: string;
  time_now: string;
  token: string;
}

const request = axios.create({
  timeout: 50000,
  withCredentials: true,
});
request.interceptors.request.use((config) => {
  // APP might inject "null" as auth token when user is not logged, don't pass "null" to backend
  const authToken = authTokenInCookie();
  if (authToken && authToken !== 'null') {
    config.headers.UserToken = authToken;
  }
  return config;
});
//TODO: may consider to change the rejected object "code" and "msg" to "ret_code" and "ret_msg"
export const req = <T>(
  reqUrl: string,
  params?: ApiRequestParams,
  externals?: ApiRequestExternals
): Promise<ApiResponse<T>> => {
  const req = (externals || {}).method === 'POST' ? request.post : request.get;
  const { errorCode = {} } = getGlobalLocaleMsg();

  return new Promise((resolve, reject) => {
    req(reqUrl, params)
      .then(function (response) {
        const { data, status } = response;
        const { ret_code, ret_msg, token } = response?.data;

        // when the API response returns a valid token, store in cookie that expires 7 days from now
        if (
          typeof token !== 'undefined' &&
          token !== null &&
          token !== 'null'
        ) {
          Cookie.set(authTokenName, token, {
            expires: 7,
            path: '/',
            domain: cookieDomain,
          });
        }
        if (ret_code !== 0 || status !== 200) {
          if (!externals.hideToast) {
            const i18nMessage =
              errorCode && errorCode[ret_code] ? errorCode[ret_code] : '';
            failedToast(`${ret_code}: ${i18nMessage || ret_msg}`);
          }
          if (!externals.isRefresh) {
            // 用户profile接口没有登录默认是 10007 这里把这个接口除去
            if (ret_code === 10007) window.location.reload();
          }
          return reject({
            msg: ret_msg,
            code: ret_code,
          });
        }
        return resolve(data);
      })
      .catch(function (error) {
        const { ret_code, ret_msg } = error?.response?.data || {};
        if (ret_code) {
          if (!externals.hideToast) {
            const i18nMessage =
              errorCode && errorCode[ret_code] ? errorCode[ret_code] : '';
            failedToast(`${ret_code}: ${i18nMessage || ret_msg}`);
          }
          return reject({
            code: ret_code,
            msg: ret_msg,
          });
        }
        if (!externals.hideToast) {
          failedToast(`${error.message}`);
        }
        return reject({
          code: -1,
          msg: error.message,
        });
      });
  });
};
